import {translate} from 'views/module';
import {
  CleanHandsOutlined,
  MedicationLiquidOutlined,
  RestaurantOutlined,
  CheckCircle,
  InfoOutlined,
  ReportProblem,
  AssistWalkerOutlined,
  CleaningServicesOutlined,
  PsychologyOutlined,
} from 'views/icons';

const DifficultyConfig = {
  EASY: {
    label: translate('form.Summary.DifficultyEasy'),
    icon: CheckCircle,
    iconColor: 'success',
    bg: '#e8f5e9',
    description: translate('form.Summary.DifficultyEasyDescription'),
  },
  MEDIUM: {
    label: translate('form.Summary.DifficultyMedium'),
    icon: InfoOutlined,
    iconColor: 'warning',
    bg: '#fff8e1',
    description: translate('form.Summary.DifficultyMediumDescription'),
  },
  HARD: {
    label: translate('form.Summary.DifficultyHard'),
    icon: ReportProblem,
    iconColor: 'error',
    bg: '#fdecea',
    description: translate('form.Summary.DifficultyHardDescription'),
  },
};

const FormIcons = {
  'CLIENT_MOBILITY_INTAKE_FORM': AssistWalkerOutlined,
  'CLIENT_PERSONAL_CARE_INTAKE_FORM': CleanHandsOutlined,
  'CLIENT_MEALS_INTAKE_FORM': RestaurantOutlined,
  'CLIENT_MEDICATIONS_INTAKE_FORM': MedicationLiquidOutlined,
  'CLIENT_CHORES_INTAKE_FORM': CleaningServicesOutlined,
  'CLIENT_COGNITIVE_SUPPORT_INTAKE_FORM': PsychologyOutlined,
};

const FormSteps = {
  START: 'START',
  SCHEDULE: 'SCHEDULE',
  CAREPLAN: 'CAREPLAN',
  CAREGIVER_MATCHING: 'CAREGIVER_MATCHING',
};

const FormKeysToFilter = {
  'Mobility': 'CLIENT_MOBILITY_INTAKE_FORM',
  'Personal-Care': 'CLIENT_PERSONAL_CARE_INTAKE_FORM',
  'Meal-Prep': 'CLIENT_MEALS_INTAKE_FORM',
  'Medication': 'CLIENT_MEDICATIONS_INTAKE_FORM',
  'Cleaning': 'CLIENT_CHORES_INTAKE_FORM',
  'Cognitive-Support': 'CLIENT_COGNITIVE_SUPPORT_INTAKE_FORM',
};

export {
  DifficultyConfig,
  FormIcons,
  FormSteps,
  FormKeysToFilter,
};
